import router from '@/router/router'
import store from '@/store'
import { Config } from '@/util/configAll.cjs'

/**
 * 清空缓存，返回登录页
 */
export const clearStorage = () => {
  store.dispatch('LogOut').then(() => {
    localStorage.clear()
    sessionStorage.clear()
    router.push({ path: Config.authPageUrl })
  })
}

